/* globals $ */
/**
 * Serializes the form and builds an object.
 * Usage example:
 *       $('form').serializeObject();
 *
 * @link http://stackoverflow.com/questions/1184624/convert-form-data-to-js-object-with-jquery
 * @return object
 */
$.fn.serializeObject = function() {
    'use strict';
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};
